import { useState, useEffect, useCallback } from 'react';

export interface CookieConsent {
  necessary: boolean;
  performance: boolean;
  functional: boolean;
}

const COOKIE_NAME = 'typingmasters_cookie_consent';

export const useCookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [consent, setConsent] = useState<CookieConsent | null>(null);

  useEffect(() => {
    try {
      const storedConsent = localStorage.getItem(COOKIE_NAME);
      if (storedConsent) {
        setConsent(JSON.parse(storedConsent));
        setShowBanner(false);
      } else {
        setShowBanner(true);
        setConsent(null);
      }
    } catch (e) {
      console.error("Could not parse cookie consent from localStorage", e);
      setShowBanner(true);
      setConsent(null);
    }
  }, []);

  const acceptAll = useCallback(() => {
    const newConsent: CookieConsent = {
      necessary: true,
      performance: true,
      functional: true,
    };
    localStorage.setItem(COOKIE_NAME, JSON.stringify(newConsent));
    setConsent(newConsent);
    setShowBanner(false);
  }, []);

  const rejectAll = useCallback(() => {
    const newConsent: CookieConsent = {
      necessary: true,
      performance: false,
      functional: false,
    };
    localStorage.setItem(COOKIE_NAME, JSON.stringify(newConsent));
    setConsent(newConsent);
    setShowBanner(false);
  }, []);

  const savePreferences = useCallback((preferences: CookieConsent) => {
    const newConsent: CookieConsent = {
        ...preferences,
        necessary: true, // Strictly necessary cookies are always enabled
    };
    localStorage.setItem(COOKIE_NAME, JSON.stringify(newConsent));
    setConsent(newConsent);
    setShowBanner(false);
  }, []);

  return { showBanner, consent, acceptAll, rejectAll, savePreferences };
};